import { render, staticRenderFns } from "./fakeLine.vue?vue&type=template&id=043a70a2&scoped=true&"
import script from "./fakeLine.vue?vue&type=script&lang=js&"
export * from "./fakeLine.vue?vue&type=script&lang=js&"
import style0 from "./fakeLine.vue?vue&type=style&index=0&id=043a70a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a70a2",
  null
  
)

export default component.exports